import PropTypes from 'prop-types';
export const socialsPropTypes = {
  /**
   * Links to socials: Muckrack and LinkedIn
   */
  socials: PropTypes.exact({
    muckrack: PropTypes.string,
    linkedin: PropTypes.string
  })
};